/////////////////////////////////////////////////V5CommentStart
// 2021-03-16 - Big Cleanup
/////////////////////////////////////////////////V5CommentEnd 
import React from 'react'
import {
  Col,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'
import queryString from 'query-string'

const FieldGroup = ({ id, label, help, type = 'text', value, ...props }) => {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl
        name={id}
        value={typeof value === undefined || value === null ? '' : value}
        componentClass={type === 'select' ? 'select' : 'input'}
        {...props}
        {...(type === 'select' ? {} : { type })}
      />
      {help && (
        <Col xs={9} xsOffset={3}>
          <HelpBlock>{help}</HelpBlock>
        </Col>
      )}
    </FormGroup>
  )
}

//---------------------------------------
// 
//---------------------------------------
export default class DataSort extends React.Component {
  //---------------------------------------
  // 
  //---------------------------------------
  handleChangeSort = event => {
    const { value: sort = '' } = event.currentTarget

    //ddfix, not very clever .
    const mypathname = window.location.pathname.toLowerCase() //returns the current url minus the domain name.
    var newpath=''
    if (mypathname.includes("dealers") && mypathname.includes("inventory")) 
     newpath=window.location.pathname
    else 
    newpath ='/inventory'


    let search = { ...this.props.search, sort }
    if (!search.sort) {
      delete search.sort
    }
    search = '?' + queryString.stringify(search)
    this.props.history.push({ pathname: newpath, search })
  }
  
  
  //---------------------------------------
  // 
  //---------------------------------------
  render = () => {

       var tempsort=this.props.search.sort || ''
   
      //ddfix , lazy code
    if (tempsort)
    {
    var tempstate = JSON.parse(localStorage.getItem('state'))
    tempstate.myBasicParams.sort=tempsort
    localStorage.setItem('state', JSON.stringify(tempstate))
    } 
    else 
    {var tempstate2 = JSON.parse(localStorage.getItem('state'))
    tempsort=tempstate2.myBasicParams.sort
    }

    return (
      <Form
        inline
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onCancel={this.handleCancel}
        id={'FilterForm-' + (this.props.id || '')}
        style={{ display: 'inline-block' }}
      >
        <FieldGroup
          type="select"
          className="btn btn-default"
          value={tempsort}
          onChange={this.handleChangeSort}
        >
          <option value="+CDISTANCE">Nearest First</option>
          <option value="+price">Lowest price first</option>
          <option value="-price">Highest price first</option>
          <option value="+year">Oldest first</option>
          <option value="-year">Newest first</option>
          <option value="+mileage">Lowest mileage first</option>
          <option value="-mileage">Highest mileage first</option>
          <option value="+body">Order By BodyStyle</option>
          <option value="+dealer">Order by DealerName</option>
        </FieldGroup>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/Sort.js